import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from "./utils/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./componnents/context/AppContext";
import axios from 'axios';

axios.defaults.baseURL = 'https://app.hoopo.tech:3022';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

